import { BundleBuilderStoreMixinComponent } from '@theme/bundle-builder-mixin-store';

/**
 * @typedef {{ errorMessage: string | null }} BundleBuilderState
 * @property {string | null} errorMessage
 */

/**
 * @typedef {Object} BundleBuilderRefs
 * @property {HTMLElement} errorRegion
 * @property {HTMLElement} errorMessage
 */

export class BundleBuilderErrorComponent extends BundleBuilderStoreMixinComponent {
  requiredRefs = ['errorMessage'];

  /** @type {string | null} */
  #currentErrorMessage = null;

  /**
   * @param {string} message
   */
  renderError(message) {
    this.#currentErrorMessage = message;
    /** @type {HTMLElement} */ (this.refs.errorMessage).textContent = message;
    /** @type {HTMLElement} */ (this).hidden = false;

    requestAnimationFrame(() => {
      /** @type {HTMLElement} */ (this)?.focus();
    });
  }

  removeError() {
    this.#currentErrorMessage = null;
    /** @type {HTMLElement} */ (this.refs.errorMessage).textContent = '';
    /** @type {HTMLElement} */ (this).hidden = true;
  }

  /**
   * @param {BundleBuilderState} state
   */
  onStateUpdate(state) {
    if (state.errorMessage) {
      if (state.errorMessage !== this.#currentErrorMessage) {
        this.renderError(state.errorMessage);
      }
      return;
    }
    if (this.#currentErrorMessage) {
      this.removeError();
    }
  }
}

if (!customElements.get('bundle-builder-error-component')) {
  customElements.define('bundle-builder-error-component', BundleBuilderErrorComponent);
}